import "./styles.css";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import devLabsLogo from "../../assets/images/devlabs_logo_white_ver1.svg";
import { Link, useLocation } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { roles, sidenavModules } from "./constant";
import RouteContext from "../../utils/context/RouteContext";

export const Sidenav = () => {
  const [isOpen, setIsOpen] = useState(null);
  const [activeItem, setActiveItem] = useState("");
  const [active, setActive] = useState(null);
  const { accessibleModules, setAccessibleModules, role, setRole } =
    useContext(RouteContext);

  const NavbarClicked = (item) => {
    setActiveItem(item);
  };

  const location = useLocation();

  const access = JSON.parse(localStorage.getItem("user"));

  const levelPermission = access?.subAdmin?.level?.levelPermission;

  //  const {role} = useContext(RouteContext);

  console.log("role -> ", role);

  useEffect(() => {
    if (levelPermission) {
      const levelsAllowed = levelPermission.filter(
        (level) => level.read || level.write
      );
      const resp = levelsAllowed.map((item) => item.module.name);
      resp.push("Dashboard");
      setAccessibleModules(resp);
    }
    setRole(access?.role);
  }, []);

  const navigate = useNavigate();

  return (
    <>
      <Sidebar className="sidenav">
        <Menu className="sidenav-container " >
          <div className="sidenav-header-container ">
            <img
              style={{
                height: "5rem",
                width: "12rem",
                cursor: "pointer",
                alignSelf: "center",
                marginLeft: "1.5rem",
              }}
              src={devLabsLogo}
              onClick={() => {
                navigate("/dashboard");
              }}
              alt="logo"
            />
          </div>
          {sidenavModules?.map?.(
            ({ name, icon, subMenu, route, id }) =>
              (role === roles.ADMIN || accessibleModules.includes(name)) &&
              (route ? (
                <>
                  <Link to={route} style={{ textDecoration: "none" }}>
                    <MenuItem
                      onClick={() => NavbarClicked(name)}
                      active={location.pathname === route}
                      className={`sidenav-item${
                        activeItem === name ? " active" : ""
                      }`}
                      prefix={icon}
                    >
                      {name}
                    </MenuItem>
                  </Link>
                </>
              ) : (
                <>
                  <SubMenu
                    className="sidenav-item"
                    label={name}
                    prefix={icon}
                    open={active === id}
                    onClick={() => {
                      setIsOpen((prev) => (prev === id ? null : id));
                      setActive((prev) => (prev === id ? null : id));
                    }}
                    suffix={
                      <ArrowDropDownOutlinedIcon
                        style={{
                          transform: isOpen === id ? "rotate(180deg)" : "none",
                        }}
                      />
                    }
                  >
                    {subMenu?.map((subMenuItem) => (
                      <Link to={subMenuItem?.route} style={{ textDecoration: "none" }}>
                        <MenuItem
                          active={subMenuItem?.children?.includes(
                            location.pathname
                          )}
                          className="sidenav-sub-item"
                        >
                          {subMenuItem?.name}
                        </MenuItem>
                      </Link>
                    ))}
                  </SubMenu>
                </>
              ))
          )}

          {/* <MenuItem
            onClick={() => NavbarClicked("Certification")}
            active={location.pathname === "/Certification"}
            className={`sidenav-item${
              activeItem === "Certification" ? " active" : ""
            }`}
            prefix={<WorkspacePremiumOutlinedIcon fontSize="small" />}
          >
            Certification
          </MenuItem> */}

          {/* <MenuItem
            prefix={<ReportGmailerrorredOutlinedIcon />}
            onClick={() => NavbarClicked("Report")}
            active={location.pathname === "/Report"}
            className={`sidenav-item${
              activeItem === "Report" ? " active" : ""
            }`}
          >
            Report
          </MenuItem> */}
        </Menu>
      </Sidebar>
    </>
  );
};
